function Skills(){
    return (
        <>
          <div className="Home_Div d-flex flex-wrap p-4 justify-content-around align-items-center">
            <div className="Intro">
              <h1>HTML</h1>
              <p>
              As a beginner in web development, I'm diving into the world of HTML. Learning the language of the web, I construct the basic structure of websites, defining their content and layout, and setting the foundation for my digital endeavors.


              </p>
            </div>
            <div className="Intro">
              <h1>CSS</h1>
              <p>
              With CSS, I explore the art of web styling. Understanding its intricacies, I breathe life into HTML elements, crafting visually appealing and responsive designs. Each line of code refines the user experience, transforming static pages into dynamic, aesthetically pleasing interfaces.
              </p>
            </div>
            <div className="Intro">
              <h1>JAVASCRIPT</h1>
              <p>JavaScript, the language of interactivity, captivates me. With its power, I add dynamic features to websites, making them responsive and engaging. I delve into the logic of programming, learning to control and manipulate web elements, enabling seamless user interactions and immersive online experiences.

</p>
            </div>
            <div className="Intro">
              <h1>JAVA</h1>
              <p>Stepping into the realm of backend development, Java beckons. I embark on a journey to comprehend its robust syntax and object-oriented paradigms. As a foundational language for server-side applications, Java equips me with the skills to create scalable, secure, and efficient digital solutions.</p>
            </div>
            <div className="Intro">
              <h1>MONGODB</h1>
              <p>MongoDB, the NoSQL database, captures my attention. Diving into its schema-less, document-oriented structure, I grasp the art of handling diverse data types. With MongoDB, I embrace the power of flexibility and scalability, mastering the storage and retrieval of vast datasets for my web applications.</p>
            </div>
            <div className="Intro">
              <h1>EXPRESS</h1>
              <p>Express.js, a minimalist and flexible Node.js web application framework, becomes my gateway to backend web development. Its simplicity and speed empower me to create robust APIs and dynamic server-side applications. I unravel the intricacies of routing, middleware, and HTTP requests, shaping my expertise in server-side scripting.</p>
            </div>
            <div className="Intro">
              <h1>REACT</h1>
              <p>In the realm of frontend frameworks, React emerges as my muse. Harnessing its component-based architecture, I craft interactive and responsive user interfaces. I explore the virtual DOM, state management, and component lifecycle, transforming complex design ideas into elegant, modular, and efficient React applications.</p>
            </div>
          </div>
        </>
      );
}
export default Skills;